import { AccountContactType } from "./signature.interface";

import { SignatureType } from "@/modules/Contracts/enums";

export function mapContactType(
  input: SignatureType | string
): AccountContactType {
  const mapping: Record<SignatureType | string, AccountContactType> = {
    [SignatureType.ELETRONIC]: AccountContactType.EMAIL,
    [SignatureType.ELETRONIC_WHATSAPP]: AccountContactType.WHATSAPP,
    [SignatureType.STANDARD]: AccountContactType.STANDARD
  };

  const inputExists = input in mapping;

  if (!inputExists) {
    throw new Error(`Tipo de contrato não encontrado: ${input}`);
  }

  return mapping[input];
}
